import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    padding: 0,
    '&:hover': {
      backgroundColor: colors.white,
      '& svg': {
        fill: colors.primary,
      },
    },
    '& svg': {
      fill: colors.inputBorder,
      '&:nth-of-type(2)': {
        width: '0.8em',
        height: '0.8em',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%) scale(0)',
      },
    },
    '&.Mui-checked': {
      backgroundColor: colors.bgTertiary,
      '& svg': {
        fill: colors.primary,
        '&:nth-of-type(2)': {
          transform: 'translate(-50%, -50%) scale(1)',
        },
      },
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
});
